"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWFType = exports.MarketFeedType = exports.MetadataFilter = exports.StreamingMetadataEvent = exports.FIELD_ENUMERATION_PARAMS = exports.FIELD_DESCRIPTION_PARAMS = exports.METADATA_FIELD_NAME = exports.METADATA_ENUM_NAME = exports.DICTIONARY_DOMAIN = void 0;
const delivery_1 = require("../delivery");
const state_1 = require("../state");
exports.DICTIONARY_DOMAIN = 'Dictionary';
exports.METADATA_ENUM_NAME = 'RWFEnum';
exports.METADATA_FIELD_NAME = 'RWFFld';
exports.FIELD_DESCRIPTION_PARAMS = 'FieldDescriptionParams';
exports.FIELD_ENUMERATION_PARAMS = 'FieldEnumerationParams';
exports.StreamingMetadataEvent = Object.assign({}, state_1.StateEvent);
var MetadataFilter;
(function (MetadataFilter) {
    MetadataFilter[MetadataFilter["DICTIONARY_INFO"] = 0] = "DICTIONARY_INFO";
    MetadataFilter[MetadataFilter["DICTIONARY_MINIMAL"] = 3] = "DICTIONARY_MINIMAL";
    MetadataFilter[MetadataFilter["DICTIONARY_NORMAL"] = 7] = "DICTIONARY_NORMAL";
    MetadataFilter[MetadataFilter["DICTIONARY_VERBOSE"] = 15] = "DICTIONARY_VERBOSE";
})(MetadataFilter || (exports.MetadataFilter = MetadataFilter = {}));
var MarketFeedType;
(function (MarketFeedType) {
    MarketFeedType[MarketFeedType["Unknown"] = -1] = "Unknown";
    MarketFeedType[MarketFeedType["Alphanumeric"] = 0] = "Alphanumeric";
    MarketFeedType[MarketFeedType["Price"] = 1] = "Price";
    MarketFeedType[MarketFeedType["Integer"] = 2] = "Integer";
    MarketFeedType[MarketFeedType["Date"] = 3] = "Date";
    MarketFeedType[MarketFeedType["Time"] = 4] = "Time";
    MarketFeedType[MarketFeedType["Enumerated"] = 5] = "Enumerated";
    MarketFeedType[MarketFeedType["Binary"] = 6] = "Binary";
})(MarketFeedType || (exports.MarketFeedType = MarketFeedType = {}));
var RWFType;
(function (RWFType) {
    RWFType[RWFType["Unknown"] = 0] = "Unknown";
    RWFType[RWFType["Int"] = 3] = "Int";
    RWFType[RWFType["UInt"] = 4] = "UInt";
    RWFType[RWFType["Float"] = 5] = "Float";
    RWFType[RWFType["Double"] = 6] = "Double";
    RWFType[RWFType["Real"] = 8] = "Real";
    RWFType[RWFType["Date"] = 9] = "Date";
    RWFType[RWFType["Time"] = 10] = "Time";
    RWFType[RWFType["DateTime"] = 11] = "DateTime";
    RWFType[RWFType["QOS"] = 12] = "QOS";
    RWFType[RWFType["Status"] = 13] = "Status";
    RWFType[RWFType["Enumeration"] = 14] = "Enumeration";
    RWFType[RWFType["Array"] = 15] = "Array";
    RWFType[RWFType["Buffer"] = 16] = "Buffer";
    RWFType[RWFType["StringAscii"] = 17] = "StringAscii";
    RWFType[RWFType["StringUTF8"] = 18] = "StringUTF8";
    RWFType[RWFType["StringRMTES"] = 19] = "StringRMTES";
    RWFType[RWFType["Opaque"] = 130] = "Opaque";
    RWFType[RWFType["XML"] = 131] = "XML";
    RWFType[RWFType["FieldList"] = 132] = "FieldList";
    RWFType[RWFType["ElementList"] = 133] = "ElementList";
    RWFType[RWFType["AnsiPage"] = 134] = "AnsiPage";
    RWFType[RWFType["FilterList"] = 135] = "FilterList";
    RWFType[RWFType["Vector"] = 136] = "Vector";
    RWFType[RWFType["Map"] = 137] = "Map";
    RWFType[RWFType["Series"] = 138] = "Series";
    RWFType[RWFType["Msg"] = 141] = "Msg";
})(RWFType || (exports.RWFType = RWFType = {}));
